import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

let api: AxiosInstance = axios.create({
  baseURL: (window as any).env.base_url,
});

api.interceptors.request.use(async (config) => {
  config.baseURL = (window as any).env.base_url;
  config.headers["Authorization"] = localStorage.getItem("accessToken") ?? "";

  //START---> Check if params exist and are objects
  if (config.params && typeof config.params === "object") {
    // Remove empty params
    Object.keys(config.params).forEach((key) => {
      if (
        config.params[key] === undefined ||
        config.params[key] === null ||
        config.params[key] === ""
      ) {
        delete config.params[key];
      }
    });
  }
  //END---> Check if params exist and are objects

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if ("config" in error) {
      const originalConfig = error.config as AxiosRequestConfig & {
        _retry: boolean;
      };
      if (error.response) {
        if (error.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;

          const refreshToken = localStorage.getItem("refreshToken");

          try {
            const newToken = await axios.post(
              `${(window as any).env.base_url}/v1/auth/refresh-token`,
              {
                "refresh_token": refreshToken,
              }
            );
            localStorage.setItem('accessToken', newToken.data.access_token)
            localStorage.setItem('refreshToken', newToken.data.refresh_token)

            originalConfig.headers = {
              ...originalConfig.headers,
              Authorization: `${newToken.data.access_token}`,
            };
          } catch (er) {
            if (axios.isAxiosError(er)) {
              if (er.response?.status === 403) {
                localStorage.clear();
                window.location.replace('/auth/login');
              }
            }
          }

          return axios(originalConfig);
        }
      }
    }

    return Promise.reject(error);
  }
);

export const API = api;
